/**
 * Device types that do not support shelly-lnm in firmware. The Local Network Messaging
 * setting must not appear for these models regardless of reported firmware version.
 *
 * Source: FE-1374 (Jira) — “devices that will not support LNM” checklist; keep in sync with
 * that list (model → `deviceType`).
 */
const LOCAL_NETWORK_MESSAGING_EXCLUDED_DEVICE_TYPES = new Set<string>([
	'S3SN-0082A', // AlarmBridge
	'S3SN-1U12A', // AZHT
	'S3GW-1DBT002', // BluAssist
	'S3GW-1DBT001', // BluGwG3
	'S0GW-0ABT001', // BluGwLoqed
	'S1CM-0DXW00', // Camera
	'S3GW-0D4G0EU', // CellGw
	'S4PB-00CU000002', // Cury
	'S4PB-06A7000101', // DaisyEM
	'S4DM-0A201WW', // DualDimmerG4
	'S4SN-0071A', // FloodSensorG4
	'S3SN-0U12A', // HTG3
	'S3GW-0DMB0', // MBGWG3
	'S3SW-001X8EU', // Mini1G3
	// 'S4PB-0916176901', // MMotors
	'S3PB-O3AR000001', // Ogemray25
	'S3PL-20112EU', // OutdoorPlugSG3
	'S3SN-0U53X', // Pill
	'S3PL-30110EU', // PlugMG3
	'S3PL-00115US', // PlugMUSG3
	'S3PL-00112EU', // PlugSG3
	'EF3PL-00112EU', // PlugSG3EF
	'EFNPL-00112UK', // PlusPlugUKEF
	'SNDC-0D4P10WW', // PlusRGBWPM
	'SNSN-0031Z', // PlusSmoke
	'SNSN-0043X', // PlusUni
	'SNDM-0013US', // PlusWallDimmer
	'S4PB-00C0187105', // PowerTrack500
	'S4SN-0U61X', // PresenceG4 / PresenceG4ZB
	'SPSW-104PE16EU', // Pro4PM
	'SPCB-04VENEU', // ProCB
	'SPDM-002PE01EU', // ProDimmerx
	'SPDC-0D5PE16EU', // ProRGBWWPM
	'S3PB-0709114901', // RaexRail
	'S3SW-002P16EU', // S2PMG3 / S2PMG4ZB (same deviceType)
	'S3SH-0A2P4EU', // S2PMG3Shutter
	'S4SW-002P16EU', // S2PMG4
	'S4SN-1031Z', // SmokeG4
	'S4SN-0031Z', // SmokeUSG4
	'S3PB-0SWSUEU001', // WallSocketEUG3
	'S3SW-1A1X5US', // WallSwitch3WayUSG3
	'S3SW-0A1X5US', // WallSwitchUSG3
	'S3MX-0A', // XMOD1
	'S3XT-0S', // XT1
	'S3PB-0A15194101', // YihaoRopeMotor
]);

export function isLocalNetworkMessagingExcludedDeviceType(deviceType: string | undefined): boolean {
	if (!deviceType) return false;
	return LOCAL_NETWORK_MESSAGING_EXCLUDED_DEVICE_TYPES.has(deviceType);
}
